var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { sortBy } from "lodash";
import { isBrusselsZip, isFlemishZip } from "../../utils/property.utils";
import { getPagedId as getPagedIdBase, } from "../generic/paged.utils";
import { ETemplateRegionBelgium } from "./template.types";
export var getPagedId = function (params) {
    return getPagedIdBase(__assign(__assign({}, params), { entityName: "template" }));
};
export var getRegionByZip = function (zip) {
    if (isBrusselsZip(zip)) {
        return ETemplateRegionBelgium.Brussels;
    }
    if (isFlemishZip(zip)) {
        return ETemplateRegionBelgium.Flanders;
    }
    return ETemplateRegionBelgium.Wallonia;
};
export var sortByRegion = function (templates, property) {
    if (!(property === null || property === void 0 ? void 0 : property.zip)) {
        return templates;
    }
    var region = getRegionByZip(property.zip);
    var sortedTemplates = sortBy(templates, [
        function (template) { return template.region !== region; },
    ]);
    return sortedTemplates;
};
